import { LitElement, html, css } from 'lit';
import '../cbom-configurator/CbomConfigurator';
import importedCaretUp from '../assets/svg/caret-up.svg';
import importedCaretDown from '../assets/svg/caret-down.svg';
import importedStackedBlocks from '../assets/svg/stacked-blocks.svg';

const caretUp = `data:image/svg+xml;base64,${btoa(importedCaretUp)}`;
const caretDown = `data:image/svg+xml;base64,${btoa(importedCaretDown)}`;
const stackedBlocks = `data:image/svg+xml;base64,${btoa(
  importedStackedBlocks
)}`;

class CbomMobileCta extends LitElement {
  // Properties
  static properties = {
    open: { type: Boolean },
    name: { type: String },
  };

  // Styles
  static styles = css`
    .cbom-mobile-cta-button {
      display: block;
      width: 100%;
      position: relative;
      padding: 11px;
      background: rgba(217, 217, 217, 0.5);
      font-family: 'Arial';
      font-style: normal;
      font-weight: 700;
      font-size: 15px;
      line-height: 17px;
      text-align: center;
      color: #434649;
      cursor: pointer;
      border: none;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
    }
    .cbom-mobile-cta-button.open {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom-style: none;
    }
    .cbom-mobile-cta-button-icon-caret {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 13px;
    }
    .cbom-mobile-cta-button-text {
      position: relative;
    }
    .cbom-mobile-cta-button-icon {
      position: absolute;
      top: -7px;
      left: -42px;
    }
    .panel {
      border: 1px solid #e5e5e5;
      border-top-style: none;
      display: none;
    }
    .panel.open {
      display: block;
    }
  `;

  _onCtaButtonClick() {
    this.open = !this.open;
    this.dispatchEvent(
      new CustomEvent('cbommobilectaclick', {
        detail: {
          open: this.open,
        },
      })
    );
  }

  renderIcon = () => html``;

  render() {
    return html`
      <button
        @click=${this._onCtaButtonClick}
        class="cbom-mobile-cta-button ${this.open ? 'open' : ''}
      "
      >
        <span class="cbom-mobile-cta-button-text">
          <img
            class="cbom-mobile-cta-button-icon"
            src=${stackedBlocks}
            alt=""
          />
          ${this.name}
        </span>
        <img
          class="cbom-mobile-cta-button-icon-caret"
          src=${this.open ? caretUp : caretDown}
          alt=""
        />
      </button>
    `;
  }
}

customElements.define('cbom-mobile-cta', CbomMobileCta);
